<template>
    <div
        class="sensor-selector d-flex flex-column flex-md-row justify-content-center"
    >
        <div class="sensor-selector-box d-flex flex-column card">
            <div class="bg-light border-bottom p-2 sensor-selector-title">
                {{ availableTitle }}
            </div>
            <div class="p-2">
                <div class="input-group input-group-sm">
                    <div class="input-group-prepend">
                        <div class="input-group-text">
                            <i class="fas fa-search" />
                        </div>
                    </div>
                    <input
                        v-model.trim="query"
                        type="text"
                        class="form-control"
                        placeholder="Filtrar"
                        :disabled="disabled"
                    />
                    <div v-if="query.length > 0" class="input-group-append">
                        <button
                            v-b-tooltip.hover.right="'Limpar filtro'"
                            class="btn btn-outline-secondary"
                            type="button"
                            data-qa="clean-query"
                            :disabled="disabled"
                            @click="query = ''"
                        >
                            <i class="fas fa-times-circle" />
                        </button>
                    </div>
                </div>
            </div>
            <select
                v-model="availableList"
                class="custom-select flex-grow-1 border-top border-bottom rounded-0 border-left-0 border-right-0"
                data-qa="select-available"
                :disabled="disabled"
                multiple
            >
                <option
                    v-for="option in computedAvailable"
                    :key="option.id"
                    :value="option.id"
                >
                    {{ option.name }}
                </option>
            </select>
            <div>
                <button
                    class="btn btn-sm btn-link text-decoration-none btn-block py-1"
                    type="button"
                    :disabled="computedAvailable.length === 0 || disabled"
                    data-qa="to-selected-all"
                    @click="onSelectAll"
                >
                    Selecionar todos
                    <i class="fas fa-chevron-circle-right fa-fw" />
                </button>
            </div>
        </div>
        <ul
            class="sensor-selector-chooser list-unstyled border rounded align-self-center mb-md-0 mb-2 mt-md-0 mt-2 mx-md-2 mx-0 p-0 d-md-block d-flex"
        >
            <li class="mb-0 mb-md-3 mr-4 mr-md-0">
                <button
                    class="btn btn-link p-1"
                    type="button"
                    :disabled="availableList.length === 0 || disabled"
                    data-qa="to-selected"
                    @click="onSelect"
                >
                    <i class="fas fa-arrow-circle-right" />
                </button>
            </li>
            <li>
                <button
                    class="btn btn-link p-1"
                    type="button"
                    :disabled="selectedList.length === 0 || disabled"
                    data-qa="to-available"
                    @click="onDeselect"
                >
                    <i class="fas fa-arrow-circle-left" />
                </button>
            </li>
        </ul>
        <div class="sensor-selector-box d-flex flex-column card">
            <div class="text-white bg-secondary p-2 sensor-selector-title">
                {{ selectedTitle }}
            </div>
            <select
                v-model="selectedList"
                class="custom-select flex-grow-1 border-top border-bottom rounded-0 border-left-0 border-right-0"
                multiple
                data-qa="select-selected"
                :disabled="disabled"
            >
                <option
                    v-for="option in selected"
                    :key="option.id"
                    :value="option.id"
                >
                    {{ option.name }}
                </option>
            </select>
            <div>
                <button
                    class="btn btn-sm btn-link text-decoration-none btn-block py-1"
                    type="button"
                    :disabled="selected.length === 0 || disabled"
                    data-qa="to-available-all"
                    @click="onDeselectAll"
                >
                    <i class="fas fa-chevron-circle-left fa-fw" /> Remover todos
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "PrismSelector",
    props: {
        available: {
            type: Array,
            required: true
        },
        selected: {
            type: Array,
            required: true
        },
        availableTitle: {
            type: String,
            default: "Prismas disponíveis"
        },
        selectedTitle: {
            type: String,
            default: "Prismas selecionados"
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            availableList: [],
            selectedList: [],
            query: ""
        };
    },
    computed: {
        computedAvailable() {
            if (this.query === "") {
                return this.available;
            }
            const query = this.query.toUpperCase();
            return this.available.filter(item => item.name.includes(query));
        }
    },
    watch: {
        available() {
            this.availableList = [];
        },
        selected() {
            this.selectedList = [];
        }
    },
    methods: {
        onSelect() {
            this.$emit(
                "select",
                this.availableList.map(id =>
                    this.available.find(item => item.id === id)
                )
            );
        },
        onDeselect() {
            this.$emit(
                "deselect",
                this.selectedList.map(id =>
                    this.selected.find(item => item.id === id)
                )
            );
        },
        onSelectAll() {
            this.$emit("select", this.computedAvailable);
        },
        onDeselectAll() {
            this.$emit("deselect", this.selected);
        }
    }
};
</script>
